import React from 'react';
import styles from './LoadingDots.module.scss';

interface LoadingDotsProps {
  message?: string;
  className?: string;
  showMessage?: boolean;
}

/**
 * Animated loading dots component for chat AI responses.
 */
export const LoadingDots: React.FC<LoadingDotsProps> = ({
  message = 'AI is thinking...',
  className,
  showMessage = true,
}) => {
  return (
    <div className={[styles.container, className].filter(Boolean).join(' ')}>
      <div className={styles.dots} aria-label="Loading" role="status">
        {[0, 1, 2].map(i => (
          <div key={i} className={styles.dot} />
        ))}
      </div>
      {showMessage && <span className={styles.message}>{message}</span>}
    </div>
  );
};

export default LoadingDots;